import { render, staticRenderFns } from "./PatoLamps.vue?vue&type=template&id=62366147"
import script from "./PatoLamps.vue?vue&type=script&lang=js"
export * from "./PatoLamps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports